class FancySlider extends HTMLElement {
  constructor() {
    super(); // Always call super first in the constructor

    // Initialize properties
    this.mainSwiper = null;
  }

  connectedCallback() {
    this.initSwipers();
    this.updateCopyVisibility(); // Initial update for visibility
    
    //if a .swiper-slide is clicked, don't link out unless it's the active slide
    /* this.querySelector('.main-swiper').addEventListener('click', (e) => {
      const slide = e.target.closest('.swiper-slide');
      if (slide) {
        if (slide.classList.contains('swiper-slide-active')) {
          return;
        } else {
          e.preventDefault();
        }
      }
    }); */
  }

  initSwipers() {
    

    this.mainSwiper = new Swiper(this.querySelector(".main-swiper"), {
      /* autoplay: {
        delay: 3000,
      }, */
      spaceBetween: 10,
      slidesPerView: 1.7,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      
      pagination: {
        el: this.querySelector('.pagination'),
        type: 'fraction',
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.button-next'),
        prevEl: this.querySelector('.button-prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 5,
        },
      },
    });

    this.mainSwiper.on("slideChange", () => this.updateCopyVisibility());
  }

  updateCopyVisibility() {
    const productId = this.mainSwiper.slides[this.mainSwiper.activeIndex].getAttribute('data-product-id');
    const slides = this.querySelectorAll('.fs-slider__copy');
    const activeSlide = this.querySelector(`.fs-slider__copy[data-product-id="${productId}"]`);

    slides.forEach(slide => slide.classList.remove('fs-slider__copy--active'));
    if (activeSlide) {
      activeSlide.classList.add('fs-slider__copy--active');
      
      const productId = activeSlide.getAttribute('data-product-id');
      this.classList.forEach(className => {
        if (className.startsWith('product-color--')) {
          this.classList.remove(className);
        }
      });
      this.classList.add(`product-color--${productId}`);
    }
  }
}

// Define the new element
customElements.define('fancy-slider', FancySlider);